import { Video, BookOpen } from 'lucide-react';

const TUTORIALS = [
    {
        id: 'api-key',
        title: 'How to get your API key',
        description: 'Step-by-step guide to generating and adding your Gemini API key so the extension works correctly.',
        videoId: '4JoeUOpGZkQ', // Replace with actual YouTube video ID
    },
    {
        id: 'developer-mode',
        title: 'How to use the beta version (Developer Mode)',
        description: 'Guide for developers on using the ZIP build via Chrome Developer Mode for testing and beta features.',
        videoId: 'PynnOG2wWss', // Replace with actual YouTube video ID
    },
];

export const TutorialsSection = () => {
    return (
        <div className="space-y-6">
            {/* Section Header */}
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center shadow-glow"
                    style={{ background: 'linear-gradient(135deg, #06B6D4, #3B82F6)' }}>
                    <BookOpen className="w-5 h-5 text-white" />
                </div>
                <div>
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                        Getting Started
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                        Watch these quick tutorials to get up and running
                    </p>
                </div>
            </div>

            {/* Tutorial Cards */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {TUTORIALS.map((tutorial) => (
                    <div key={tutorial.id} className="card space-y-4">
                        {/* Tutorial Header */}
                        <div className="flex items-start gap-3">
                            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 bg-blue-100 dark:bg-blue-900/30">
                                <Video className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                            </div>
                            <div className="flex-1">
                                <h4 className="font-semibold text-gray-900 dark:text-white">
                                    {tutorial.title}
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                                    {tutorial.description}
                                </p>
                            </div>
                        </div>

                        {/* Video Embed */}
                        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-lg border border-gray-200 dark:border-gray-700"
                                src={`https://www.youtube.com/embed/${tutorial.videoId}`}
                                title={tutorial.title}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                ))}
            </div>

            {/* Help Section */}
            <div className="mt-6 p-4 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800">
                <div className="flex items-start gap-3">
                    <BookOpen className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
                    <div>
                        <h5 className="font-medium text-blue-900 dark:text-blue-200">
                            Need more help?
                        </h5>
                        <p className="text-sm text-blue-700 dark:text-blue-300 mt-1">
                            If you have questions or run into issues, feel free to reach out to our support team or check the documentation.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
